<template>
  <svg
    width="30"
    height="8"
    viewBox="0 0 30 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.7333 4C29.7333 1.93814 28.0619 0.266667 26 0.266667C23.9381 0.266666 22.2667 1.93814 22.2667 4C22.2667 6.06186 23.9381 7.73333 26 7.73333C28.0619 7.73333 29.7333 6.06186 29.7333 4ZM1 3.3C0.613401 3.3 0.300001 3.6134 0.300001 4C0.300001 4.3866 0.613401 4.7 1 4.7L1 3.3ZM26 3.3L1 3.3L1 4.7L26 4.7L26 3.3Z"
      fill="#E33065"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped></style>
